type HistoryChangedFieldsCarrier = {
  changedFieldsArray?: string[];
  changedFields?: string;
};

export function getHistoryChangedFields(history: HistoryChangedFieldsCarrier): string[] {
  if (history.changedFieldsArray?.length) {
    return history.changedFieldsArray;
  }

  if (!history.changedFields) {
    return [];
  }

  try {
    const parsed = JSON.parse(history.changedFields) as unknown;
    return Array.isArray(parsed) ? parsed.filter((field): field is string => typeof field === 'string') : [];
  } catch {
    return [];
  }
}
